import React from 'react';
import AppConstants from 'AppConstants';
import {ReactTitle} from 'react-meta-tags';
import Page from 'components/Page';
import { Card, CardBody, Row, Button, ButtonGroup, UncontrolledTooltip } from 'reactstrap';
import { Link } from 'react-router-dom';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { MdAdd, MdCancel, MdDelete } from 'react-icons/md';
import swal from 'sweetalert';
import axios from 'axios';
import Loader from 'react-loader';
import { formatResourceUserTypes } from './addPushNotification';

const roleLabels = {
    student: 'Students',
    parent: 'Parents',
    participant: 'Participants'
};

const statusBadges = {
    Scheduled: 'badge-info',
    Sending: 'badge-warning',
    Sent: 'badge-success',
    Failed: 'badge-danger',
    Cancelled: 'badge-secondary'
};

// Dates are stored in UTC and shown in the admin's browser timezone
export const formatDateTime = (value) => {
    if (!value) return '';
    return new Date(value).toLocaleString('en-US', {
        month: '2-digit', day: '2-digit', year: 'numeric',
        hour: 'numeric', minute: '2-digit'
    });
};

class PushNotifications extends React.Component{
    constructor(){
        super();
        this.state = {
            notifications: [],
            filter: 'All',
            page_loader : false
        }
    }
    componentDidMount(){
        this.getNotifications(this.state.filter);
        // Other pages set "active" on their nav item by hand, so clear it here
        document.querySelectorAll('[id^="navItem-"]').forEach(element => {
            if(element.id != "navItem-Push Notifications-2") element.classList.remove("active");
        });
    }
    getNotifications(filter){
        axios.post(AppConstants.API+'/pushNotifications/getAllPushNotifications', { filter: filter })
        .then(res => {
            if(res.data.Status == "Success"){
                this.setState({ notifications: res.data.data, page_loader: true });
            }else{
                this.setState({ notifications: [], page_loader: true });
            }
        })
        .catch(() => {
            this.setState({ page_loader: true });
        });
    }
    changeFilter = (filter) => () => {
        this.setState({ filter: filter });
        this.getNotifications(filter);
    }
    cancelNotification = (id) => (e) => {
        e.preventDefault();
        swal({
            title: "Are you sure?",
            text: "You want to cancel this scheduled notification?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
        .then((willCancel) => {
            if (willCancel) {
                axios.post(AppConstants.API+'/pushNotifications/cancelPushNotification', { id: id })
                .then(res => {
                    swal(res.data.msg, { icon: res.data.Status == "Success" ? "success" : "error" });
                    this.getNotifications(this.state.filter);
                });
            }
        });
    }
    deleteNotification = (id) => (e) => {
        e.preventDefault();
        swal({
            title: "Are you sure?",
            text: "You want to delete this notification?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
        .then((willDelete) => {
            if (willDelete) {
                axios.post(AppConstants.API+'/pushNotifications/deletePushNotification', { id: id })
                .then(res => {
                    swal(res.data.msg, { icon: res.data.Status == "Success" ? "success" : "error" });
                    this.getNotifications(this.state.filter);
                })
                .catch(() => {
                    swal("Problem while deleting the notification", { icon: "error" });
                });
            }
        });
    }
    showMessage(cell){
        return <div style={{ whiteSpace: 'normal' }}>{cell}</div>;
    }
    showResource(cell, row){
        if(!row.resource_id) return '-';
        const title = cell || 'Unknown resource';
        if(!row.resource_available){
            // Resource was deleted or deactivated after the notification was created
            return <div style={{ whiteSpace: 'normal' }}>{title} <span className="badge badge-secondary p-1">Unavailable</span></div>;
        }
        return <div style={{ whiteSpace: 'normal' }}>
            <Link to={"/viewResource/" + row.resource_id}>{title}</Link>
            {row.resource_user_type ? <div><small className="text-muted">Available to: {formatResourceUserTypes(row.resource_user_type) || '-'}</small></div> : null}
        </div>;
    }
    showRoles(cell, row){
        const labels = (cell || []).map(role => roleLabels[role] || role).join(', ');
        const skipped = (row.skipped_roles || []).map(role => roleLabels[role] || role).join(', ');
        if(!skipped) return labels;
        // Selected, but left out at send time because they had no access to the resource
        return <div style={{ whiteSpace: 'normal' }}>
            {labels}
            <div><small className="text-danger">Not sent to {skipped} (no access to resource)</small></div>
        </div>;
    }
    // Plain text for search, so "Parents" still finds rows where parents were skipped
    rolesText(cell){
        return (cell || []).map(role => roleLabels[role] || role).join(', ');
    }
    showType(cell){
        return cell == 'scheduled' ? 'Scheduled' : 'Immediate';
    }
    showDate(cell, row){
        if(row.status == 'Sent' || row.status == 'Failed'){
            return formatDateTime(row.sent_date);
        }
        return formatDateTime(row.scheduled_date || row.created_date);
    }
    showStatus(cell, row){
        return <span>
            <span id={`${"tooltipstatus-"}${row._id}`} className={"badge p-1 " + (statusBadges[cell] || 'badge-light')}>{cell}</span>
            {row.error ? <UncontrolledTooltip placement="top" target={`${"tooltipstatus-"}${row._id}`}>{row.error}</UncontrolledTooltip> : null}
        </span>;
    }
    showRecipients(cell, row){
        if(row.status != 'Sent' && row.status != 'Failed') return '-';
        return <span title={row.devices_count + " devices"}>{cell}</span>;
    }
    handleActions(cell, row){
        // Sending is still in progress, so it can't be cancelled or deleted yet
        if(row.status == 'Sending') return '';
        return <div className="ca-controls">
                    {row.status == 'Scheduled' &&
                    <span id={`${"tooltipcancel-"}${row._id}`} onClick={ this.cancelNotification(row._id) } className="bg-warning cst-icon"><MdCancel />
                    <UncontrolledTooltip placement="top" target={`${"tooltipcancel-"}${row._id}`}>Cancel Notification</UncontrolledTooltip>
                    </span>}
                    <span id={`${"tooltipdel-"}${row._id}`} onClick={ this.deleteNotification(row._id) } className="bg-danger cst-icon"><MdDelete />
                    <UncontrolledTooltip placement="top" target={`${"tooltipdel-"}${row._id}`}>Delete Notification</UncontrolledTooltip>
                    </span>
                </div>;
    }
    createCustomInsertButton=()=>{
        return(<span> &nbsp; <Link to={"/addPushNotification"} className="btn btn-warning" title="New Notification"><MdAdd />New Notification</Link></span>)
    }
    render(){
        const options = {
            insertBtn: this.createCustomInsertButton,
            page: 1,
            sizePerPageList: [
                { text: '5', value: 5 },
                { text: '10', value: 10 },
                { text: '20', value: 20 },
                { text: '50', value: 50 }
            ],
            sizePerPage: 10,
            pageStartIndex: 1,
            paginationSize: 3,
            paginationShowsTotal: this.state.notifications.length,
            paginationPosition: 'bottom',
            noDataText: 'No notifications found'
        };
        return(
          <Loader loaded={this.state.page_loader}  >
            <Page title="Push Notifications">
                <ReactTitle title="Push Notifications"/>
                <ul className="cst-breadcrumb">
                <li><Link to={'/dashboard'}>Dashboard</Link> </li>
                <li>Push Notifications</li>
                </ul>
                <Row>
                    <Card>
                        <CardBody>
                            <ButtonGroup className="mb-3">
                                {['All', 'Sent', 'Scheduled'].map(filter => (
                                    <Button key={filter} color="primary" outline={this.state.filter != filter} onClick={this.changeFilter(filter)}>{filter}</Button>
                                ))}
                            </ButtonGroup>
                            <p className="text-muted small mb-3">
                                A notification only reaches user types that have access to its resource (the resource's User type). Any selected user type without access is listed as "Not sent to" under Sent To.
                            </p>
                             <div>
                                <BootstrapTable data={this.state.notifications} search={ true } pagination={ true } multiColumnSearch={ true } options={ options } insertRow>
                                    <TableHeaderColumn dataField='_id' isKey={true} searchable={false} hidden={true}>ID</TableHeaderColumn>
                                    <TableHeaderColumn dataField='message' width={'20%'} dataFormat={this.showMessage.bind(this)} dataSort={true}>Message</TableHeaderColumn>
                                    <TableHeaderColumn dataField='resource_title' width={'13%'} dataFormat={this.showResource.bind(this)} dataSort={true}>Resource</TableHeaderColumn>
                                    <TableHeaderColumn dataField='roles' dataFormat={this.showRoles.bind(this)} filterValue={this.rolesText.bind(this)}>Sent To</TableHeaderColumn>
                                    <TableHeaderColumn dataField='send_type' width={'10%'} dataFormat={this.showType.bind(this)} dataSort={true}>Type</TableHeaderColumn>
                                    <TableHeaderColumn dataField='scheduled_date' width={'13%'} dataFormat={this.showDate.bind(this)} searchable={false}>Date &amp; Time</TableHeaderColumn>
                                    <TableHeaderColumn dataField='status' width={'10%'} dataFormat={this.showStatus.bind(this)} dataSort={true}>Status</TableHeaderColumn>
                                    <TableHeaderColumn dataField='recipients_count' width={'9%'} dataFormat={this.showRecipients.bind(this)} searchable={false}>Recipients</TableHeaderColumn>
                                    <TableHeaderColumn dataField='admin_name' width={'9%'}>Created By</TableHeaderColumn>
                                    <TableHeaderColumn dataField='actions' width={'8%'} dataFormat={this.handleActions.bind(this)} searchable={false} export={false}>Actions</TableHeaderColumn>
                                </BootstrapTable>
                            </div>
                        </CardBody>
                    </Card>
                </Row>
            </Page>
        </Loader>
        )
    }
}
export default PushNotifications;
